import React from 'react';
import { motion } from 'framer-motion';

const WHOP_URL = 'https://whop.com/joined/thedillonblueprint/';

export const BasketballCTA = () => {
  const scrollToContact = () => {
    const el = document.getElementById('train-with-me');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section data-testid="basketball-final-cta" className="relative bg-black py-28 px-6 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[350px] bg-white/5 rounded-full blur-[140px] pointer-events-none" />
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.8 }}
          className="font-display text-white text-4xl sm:text-6xl uppercase leading-tight"
        >
          Ready To Take Your Game To The Next Level?
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center mt-10"
        >
          <a
            data-testid="final-cta-apply"
            href={WHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-shine bg-gray-300 hover:bg-white text-black font-bold px-10 py-4 rounded-lg transition-colors"
          >
            <span className="relative z-10">Join The Community</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
